import React from "react"
import { CarouselContainer, CarouselWrapper, FoodImage } from "./styled"

// Multi-resolution images for responsive loading
import meal1x from "assets/images/ai-scan-instruction/meal@1x.webp"
import meal2x from "assets/images/ai-scan-instruction/meal@2x.webp"
import meal3x from "assets/images/ai-scan-instruction/meal@3x.webp"

import receipts1x from "assets/images/ai-scan-instruction/receipts@1x.webp"
import receipts2x from "assets/images/ai-scan-instruction/receipts@2x.webp"
import receipts3x from "assets/images/ai-scan-instruction/receipts@3x.webp"

import package1x from "assets/images/ai-scan-instruction/package@1x.webp"
import package2x from "assets/images/ai-scan-instruction/package@2x.webp"
import package3x from "assets/images/ai-scan-instruction/package@3x.webp"

import nutritionFact1x from "assets/images/ai-scan-instruction/nutrition-fact@1x.webp"
import nutritionFact2x from "assets/images/ai-scan-instruction/nutrition-fact@2x.webp"
import nutritionFact3x from "assets/images/ai-scan-instruction/nutrition-fact@3x.webp"

interface FeatureImages {
  x1: string
  x2: string
  x3: string
}

// Array of 5 slides: [meal, receipts, package, nutrition-fact, meal]
const IMAGES: FeatureImages[] = [
  {
    x1: meal1x,
    x2: meal2x,
    x3: meal3x,
  },
  {
    x1: receipts1x,
    x2: receipts2x,
    x3: receipts3x,
  },
  {
    x1: package1x,
    x2: package2x,
    x3: package3x,
  },
  {
    x1: nutritionFact1x,
    x2: nutritionFact2x,
    x3: nutritionFact3x,
  },
  {
    x1: meal1x,
    x2: meal2x,
    x3: meal3x,
  },
]

const AnimatedImageCarousel: React.FC = () => {
  return (
    <CarouselContainer>
      <CarouselWrapper>
        {IMAGES.map((images, index) => {
          // Build srcSet for responsive image loading based on device pixel ratio
          const srcSet = `${images.x1} 1x, ${images.x2} 2x, ${images.x3} 3x`

          return (
            <FoodImage key={index} src={images.x1} srcSet={srcSet} alt={`Scan feature ${index + 1}`} />
          )
        })}
      </CarouselWrapper>
    </CarouselContainer>
  )
}

export default AnimatedImageCarousel
